import {Model, FunctionFactory} from 'survey-core';
import {Survey as SurveyComponent} from 'survey-react-ui';
import {observer} from 'mobx-react';
import {PlainLightPanelless} from 'survey-core/themes';
import i18next from 'i18next';

// Register round() function for SurveyJS expressions (not built-in)
FunctionFactory.Instance.register('round', function (params: any[]) {
    if (params.length < 1) return null;
    const value = params[0];
    const decimals = params.length > 1 ? params[1] : 0;
    const multiplier = Math.pow(10, decimals);
    return Math.round(value * multiplier) / multiplier;
});

export interface ISurveyPreviewProps {
    surveyJson: any;
    rawJson: string;
    themeJson?: string;
}

// TODO: Re-enable server-side validation feedback after JsonElement fix is confirmed
const SurveyPreview: React.FC<ISurveyPreviewProps> = observer(({surveyJson, themeJson}) => {
    if (!surveyJson) return null;

    const survey = new Model(surveyJson);
    let surveyTheme = PlainLightPanelless;
    if (themeJson) {
        try {
            surveyTheme = JSON.parse(themeJson);
        } catch (e) {
            console.error('Failed to parse theme JSON', e);
        }
    }
    survey.applyTheme(surveyTheme);
    survey.locale = i18next.language;

    return <SurveyComponent model={survey}/>;
});

export default SurveyPreview;
